import { Menu } from '../../core/models/menu';

export const menus: Menu[] = [
  {
    title: 'menu.home',
    icon: 'home',
    path: '/',
  },
  {
    title: 'menu.checklists',
    icon: 'list',
    subMenu: [
      {
        title: 'menu.checklistTemplate',
        path: '/checklist/templates',
        permissions: [],
      },
      {
        title: 'menu.checklistReport',
        path: '/checklist/reports',
        permissions: [],
      },
    ],
  },
  {
    title: 'menu.inspection',
    icon: 'search',
    subMenu: [
      {
        title: 'menu.inspectionCheck',
        path: '/inspection',
        permissions: [],
      },
      {
        title: 'menu.inspectionHistory',
        path: '/inspection/history',
        permissions: [],
      },
    ],
  },
  {
    title: 'menu.admin',
    icon: 'profile',
    permissions: ['AP3720001-BRSA-CHECKLISTOUTBOUND-SCANIAIT'],
    subMenu: [
      {
        title: 'menu.adminArea',
        path: '/admin/area',
        permissions: ['AP3720001-BRSA-CHECKLISTOUTBOUND-SCANIAIT'],
      },
      {
        title: 'menu.adminBanner',
        path: '/admin/banner',
        permissions: ['AP3720001-BRSA-CHECKLISTOUTBOUND-SCANIAIT'],
      },
    ],
  },
  {
    title: 'menu.register',
    icon: 'folder',
    permissions: [
      'AP3720001-BRSA-CHECKLISTOUTBOUND-SCANIAIT',
      'AP3720001-BRSA-CHECKLISTOUTBOUND-ADM',
    ],
    subMenu: [
      { title: 'menu.adminPerson', path: '/register/person', permissions: [] },
      { title: 'menu.adminCompany', path: '/register/company', permissions: [] },
      { title: 'menu.adminPersonRole', path: '/register/position', permissions: [] },
      { title: 'menu.adminDocType', path: '/register/document-type', permissions: [] },
    ],
  },
  {
    title: 'menu.help',
    icon: 'support',
    subMenu: [
      {
        title: 'menu.tutorial',
        path: '/tutorial',
      },
      {
        title: 'menu.faq',
        path: '/faq',
      },
    ],
  },
];
